(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slides-scentya"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('scentya-banner-slider')) {
  customElements.define('scentya-banner-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.toggle = this.querySelector('[data-toggle]');
      this.frame = this.querySelector('.sc-banner__frame');
      this.index = 0;
      this.userPaused = this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.focused = false;
      this.editorPaused = false;
      this.visible = true;
      this.slides.forEach((slide, i) => { slide.hidden = i !== 0; });
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.show(i); this.refresh(); }, {signal}));
      this.toggle?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.refresh(); }, {signal});
      this.addEventListener('pointerenter', event => { if(event.pointerType !== 'touch'){this.hovered=true;this.refresh();} }, {signal});
      this.addEventListener('pointerleave', () => {this.hovered=false;this.refresh();}, {signal});
      this.addEventListener('focusin', () => {this.focused=true;this.refresh();}, {signal});
      this.addEventListener('focusout', () => {
        setTimeout(() => {if(!this.isConnected)return;this.focused=this.contains(document.activeElement);this.refresh();},0);
      }, {signal});
      document.addEventListener('visibilitychange', () => this.refresh(), {signal});
      document.addEventListener('shopify:block:select', event => {
        if(event.detail?.sectionId !== this.dataset.sectionId)return;
        const index=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail.blockId);
        if(index<0)return;
        this.editorPaused=true;this.show(index);this.refresh();
      }, {signal});
      document.addEventListener('shopify:block:deselect', event => {
        if(event.detail?.sectionId !== this.dataset.sectionId)return;
        this.editorPaused=false;this.refresh();
      }, {signal});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.refresh();},{threshold:.1});
      this.observer.observe(this);
      this.refresh();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller=null;
    }
    show(index) {
      if(!this.slides.length)return;
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;});
      this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));
    }
    refresh() {
      clearInterval(this.timer);
      const running=this.slides.length>1 && !this.userPaused && !this.hovered && !this.focused && !this.editorPaused && this.visible && document.visibilityState!=='hidden';
      this.dataset.paused=String(this.userPaused);
      if(this.toggle)this.toggle.setAttribute('aria-label',this.userPaused?this.dataset.playLabel:this.dataset.pauseLabel);
      if(this.frame)this.frame.setAttribute('aria-live',running?'off':'polite');
      if(running)this.timer=setInterval(()=>this.show(this.index+1),Math.max(3000,Number(this.dataset.interval)||3000));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
